import { CanDeactivate } from '@angular/router';
import { Injectable, OnDestroy } from '@angular/core';

import { Observable, of, Subscription } from 'rxjs';

import { MonitoringRoutingService } from '../../Core/services/monitoring-routing.service';
import { MediaSubscriptionComponent } from '../../MediaSubscriptions/components/MediaSubscription/media-subscription.component';
import { MediaSubscriptionService } from '../../Core/services/media-subscription.service';
import { MonitoringRouteModel } from '../../Shared/models/monitoring-route.model';
import { RouteType } from '../../Shared/enums/route-type.enum';

@Injectable()
export class SubscriptionsDeactivateGuard implements CanDeactivate<MediaSubscriptionComponent>, OnDestroy {

    private currentRoute: MonitoringRouteModel;

    private subscriptions: Subscription[] = [];

    constructor(
        public mediaSubscriptionService: MediaSubscriptionService,
        public monitoringRoutingService: MonitoringRoutingService
    ) {
        this.subscriptions.push(
            this.monitoringRoutingService.getCurrentRoute().subscribe(
                (currentRoute) => {
                    this.currentRoute = currentRoute;
                }
            )
        );
    }


    canDeactivate(
        component: MediaSubscriptionComponent
    ): Observable<boolean> {
        const destinationRoute = this.monitoringRoutingService.getNextRoute();
        const canSkipGuard: boolean = this.canSkipGuard(this.currentRoute, destinationRoute);

        if (canSkipGuard) {
            return of(true);
        }

        return this.mediaSubscriptionService.canDeactivate$();
    }

    /**
     * Returns boolean indicating if two routes are siblings
     *
     * @param currentRoute - route to compare
     * @param nextRoute - route to compar
     *
     * @returns boolean
     */
    private canSkipGuard(currentRoute: MonitoringRouteModel, nextRoute: MonitoringRouteModel): boolean {
        if (!nextRoute) {
            return false;
        }

        switch (currentRoute.type) {
            case RouteType.subscription:
                if (nextRoute.type === RouteType.subscriptionResults) {
                    return currentRoute.value === nextRoute.value;
                }

                return false;

            case RouteType.subscriptionResults:
                if (nextRoute.type === RouteType.subscription ||
                    nextRoute.type === RouteType.subscriptionAnalyticsDashboard ||
                    nextRoute.type === RouteType.subscriptionAnalyticsSyndicates) {
                    return currentRoute.value === nextRoute.value;
                }

                return false;

            case RouteType.subscriptionAnalyticsDashboard:
                if (nextRoute.type === RouteType.subscriptionResults) {
                    return currentRoute.value === nextRoute.value;
                }

                return false;

            case RouteType.subscriptionAnalyticsSyndicates:
                if (nextRoute.type === RouteType.subscriptionResults) {
                    return currentRoute.value === nextRoute.value;
                }

                return false;
        }

        return false;
    }

    ngOnDestroy() {
        this.subscriptions.forEach(sub => sub.unsubscribe());
    }
}
